/**
 * @generated SignedSource<<8b829ae16cc12c4f92c73f2bda26e915>>
 * @relayHash a2986ccbca3c62dc11f923e75afe6487
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d2b73b48a3c260ff9820c009a90e63fba3bc1c0bd731fbfb1e0cc79c0bcdbc60

var node = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "hubAri"
    }],
    v1 = [{
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    }],
    v2 = [{
      "kind": "Variable",
      "name": "helpCenterAri",
      "variableName": "hubAri"
    }],
    v3 = {
      "kind": "ScalarField",
      "name": "asapIssuer"
    },
    v4 = {
      "kind": "ScalarField",
      "name": "mediaCollectionName"
    },
    v5 = {
      "kind": "ScalarField",
      "name": "mediaToken"
    },
    v6 = {
      "kind": "ScalarField",
      "name": "mediaUrl"
    },
    v7 = {
      "kind": "InlineFragment",
      "selections": [{
        "concreteType": "HelpCenterBranding",
        "kind": "LinkedField",
        "name": "helpCenterBranding",
        "plural": false,
        "selections": [{
          "concreteType": "HelpCenterLogo",
          "kind": "LinkedField",
          "name": "logo",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "name": "fileId"
          }, {
            "kind": "ScalarField",
            "name": "url"
          }]
        }]
      }],
      "type": "HelpCenter"
    };
  return {
    "fragment": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Fragment",
      "name": "hubBootstrapQuery",
      "selections": [{
        "args": v1 /*: any*/,
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [{
          "kind": "RequiredField",
          "field": {
            "args": v2 /*: any*/,
            "concreteType": "HelpCenterMediaConfig",
            "kind": "LinkedField",
            "name": "mediaConfig",
            "plural": false,
            "selections": [{
              "kind": "RequiredField",
              "field": v3 /*: any*/,
              "action": "THROW",
              "path": "helpCenter.mediaConfig.asapIssuer"
            }, {
              "kind": "RequiredField",
              "field": v4 /*: any*/,
              "action": "THROW",
              "path": "helpCenter.mediaConfig.mediaCollectionName"
            }, {
              "kind": "RequiredField",
              "field": v5 /*: any*/,
              "action": "THROW",
              "path": "helpCenter.mediaConfig.mediaToken"
            }, {
              "kind": "RequiredField",
              "field": v6 /*: any*/,
              "action": "THROW",
              "path": "helpCenter.mediaConfig.mediaUrl"
            }]
          },
          "action": "THROW",
          "path": "helpCenter.mediaConfig"
        }, {
          "args": v2 /*: any*/,
          "kind": "LinkedField",
          "name": "helpCenterById",
          "plural": false,
          "selections": [v7 /*: any*/]
        }]
      }],
      "type": "Query"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Operation",
      "name": "hubBootstrapQuery",
      "selections": [{
        "args": v1 /*: any*/,
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [{
          "args": v2 /*: any*/,
          "concreteType": "HelpCenterMediaConfig",
          "kind": "LinkedField",
          "name": "mediaConfig",
          "plural": false,
          "selections": [v3 /*: any*/, v4 /*: any*/, v5 /*: any*/, v6 /*: any*/]
        }, {
          "args": v2 /*: any*/,
          "kind": "LinkedField",
          "name": "helpCenterById",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "name": "__typename"
          }, v7 /*: any*/, {
            "kind": "InlineFragment",
            "selections": [{
              "kind": "ScalarField",
              "name": "id"
            }],
            "type": "Node",
            "abstractKey": "__isNode"
          }]
        }]
      }]
    },
    "params": {
      "id": "d2b73b48a3c260ff9820c009a90e63fba3bc1c0bd731fbfb1e0cc79c0bcdbc60",
      "metadata": {},
      "name": "hubBootstrapQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "8f3b73901a79699eb8edb7f71f1d3b52";
export default node;